'use client';
import React from 'react';

export const AnimatedChangePassword: React.FC = () => (
  <div className='relative w-full h-full flex items-center justify-center p-6'>
    <style>{ `
      /* Inputs float in from top */
      .input-box {
        opacity: 0;
        transform: translateY(-40px);
        animation: floatIn 0.8s ease-out forwards;
      }
      .input-box.delay-1 { animation-delay: 0.2s; }
      .input-box.delay-2 { animation-delay: 0.4s; }

      @keyframes floatIn {
        to { opacity: 1; transform: translateY(0); }
      }

      /* Key drops in */
      .key {
        opacity: 0;
        transform: translateY(-60px) rotate(-30deg);
        animation: dropKey 0.8s ease-out forwards;
        animation-delay: 1.2s;
      }
      @keyframes dropKey {
        to { opacity: 1; transform: translateY(0) rotate(0deg); }
      }

      /* Lock opens */
      .lock-shackle {
        transform-origin: 150px 110px;
        animation: unlock 0.8s ease-in-out forwards;
        animation-delay: 2.2s;
      }
      @keyframes unlock {
        0%   { transform: rotate(0deg); }
        50%  { transform: rotate(-45deg); }
        100% { transform: rotate(0deg); }
      }

      /* Success check fades in */
      .checkmark {
        opacity: 0;
        transform: scale(0.5);
        animation: showCheck 0.6s ease-out forwards;
        animation-delay: 3.2s;
      }
      @keyframes showCheck {
        to { opacity:1; transform: scale(1); }
      }
    ` }</style>

    <svg viewBox='0 0 300 200' className='w-full max-w-sm'>
      { /* 1) Floating input boxes */ }
      <rect
          x='50'
          y='20'
          width='200'
          height='30'
          rx='6'
          fill='#FFF'
          stroke='#CBD5E1'
          strokeWidth='2'
          className='input-box delay-1'
      />
      <rect
          x='50'
          y='60'
          width='200'
          height='30'
          rx='6'
          fill='#FFF'
          stroke='#CBD5E1'
          strokeWidth='2'
          className='input-box delay-2'
      />

      { /* 2) Key dropping in */ }
      <g className='key'>
        <rect x='80' y='100' width='40' height='8' rx='2' fill='#FBBF24' />
        <circle cx='100' cy='100' r='8' fill='#FBBF24' />
        <rect x='110' y='98' width='20' height='4' fill='#FBBF24' />
      </g>

      { /* 3) Lock on right */ }
      <g>
        { /* Body */ }
        <rect
            x='140'
            y='100'
            width='60'
            height='50'
            rx='6'
            fill='#FFF'
            stroke='#093725'
            strokeWidth='4'
        />
        { /* Shackle */ }
        <path
            d='M150,100 a20,20 0 0 1 40,0'
            fill='none'
            stroke='#093725'
            strokeWidth='6'
            className='lock-shackle'
        />
      </g>

      { /* 4) Success check */ }
      <path
          d='M140,140 L155,155 L180,130'
          fill='none'
          stroke='#10B981'
          strokeWidth='6'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='checkmark'
      />
    </svg>
  </div>
);
